import { CHANGE_FILTERS_STATE, FiltersActionTypes, FiltersState } from "./types";

const defaultState: FiltersState = {
  isOpen: false
};

export default function filters(state = defaultState, action: FiltersActionTypes): FiltersState {
  switch (action.type) {
    case CHANGE_FILTERS_STATE:
      return {
        isOpen: action.isOpen
      };
    default:
      return state;
  }
}